import { Typography, Box } from "@mui/material";
import themestyle from "../theme";

const Copyright = () => {
  return (
    <Typography
      sx={{
        position: "absolute",
        bottom: { xs: 15, md: 18 },
        left: "50%",
        transform: "translateX(-50%)",
        fontWeight: 400,
        fontSize: { xs: "10px", md: "12px" },
        color: {
          xs: themestyle.colors.black,
          md: themestyle.colors.white,
        },
        fontFamily: themestyle.fontFamily.Poppins,
        textAlign: "center",
        whiteSpace: { xs: "normal", sm: "nowrap" },
        maxWidth: { xs: "90%", sm: "100%" },
        lineHeight: 1.4,
      }}
    >
      <Box component="span" sx={{ whiteSpace: "nowrap" }}>
        © {new Date().getFullYear()} Designed and Developed by{" "}
        <Box
        component="a"
        href="https://pheonixsolutions.com/"
        target="_blank"
         rel="noopener noreferrer"
         sx={{ color: "#43A047",fontWeight: 500,
          textDecoration: "none",
          cursor: "pointer",
          "&:hover": {
            textDecoration: "none",
          },
          }}
          >Pheonixsolutions
          </Box>
      </Box>
      . All rights reserved.
    </Typography>
  );
};
export default Copyright;
